import { AiOperatorFieldsQuery } from '@/graphql/generated/operations'
import { AiOperatorActionType } from '@/graphql/generated/schemas'

import { Criterion } from '../types/types'

export const AiOperatorCriterionMapper: Record<
  AiOperatorActionType.ResolveAndMarkAsFalse,
  string
> = {
  RESOLVE_AND_MARK_AS_FALSE: 'Resolve',
}

export const modifyAiOperatorCriteriaFields = (
  data: AiOperatorFieldsQuery
): Criterion[] => {
  const modifiedData: Criterion[] = data?.aiOperatorFields?.edges?.map((f) => ({
    id: f?.node?.id,
    action: AiOperatorActionType.ResolveAndMarkAsFalse,
    criterion: {
      value: f?.node?.id,
      label: f?.node?.description,
    },
    detected: true,
  }))
  return modifiedData ?? []
}
